import { computed } from '@vue/composition-api';

export function useLocalStorage (key, defaultValue) {
  return computed({
    get () {
      const value = window.localStorage.getItem(key);
      if (value) {
        try {
          return JSON.parse(value);
        } catch {
          console.warn('useLocalStorage was not able to parse JSON value'); //eslint-disable-line
          return value;
        }
      }
      return defaultValue;
    },
    set (value) {
      window.localStorage.setItem(key, JSON.stringify(value));
    },
  });
}
